import { API_URL } from '../../../app-config/constants';
import { BaseCycleDto, FeedbackCycleDto } from '../../../types/CycleDto';
import { get, remove } from '../request';

const BASE_URL = `${API_URL}/feedback-cycles`;

getCyclePreview.operation = 'READ';
export function getCyclePreview(cycleId: string): Promise<FeedbackCycleDto> {
    return get<{ model: FeedbackCycleDto }>(`${BASE_URL}/preview/${cycleId}`).then(wrapper => wrapper.model);
}

deleteCycle.operation = 'DELETE';
export function deleteCycle(cycleId: string) {
    return remove(BASE_URL + '/' + cycleId);
}

export function getCyclesWithHiddenFeedbackForUser(userId: string) {
    return get<BaseCycleDto[]>(`${BASE_URL}/hidden-feedback-for-user/${userId}`);
}
